import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const CheckinQr = ({ rowData }) => {
  const { qr_code, gym_name } = rowData || {};

  return (
    <div className="flexColListings aiFlexStart mt30">
      <h3 className="main-heading underline">{gym_name}</h3>
      <p className="general-lable">Check-In-Daily</p>
      <p className="general-lable">Get More Rewards</p>
      <p className="general-lable">Check-In With WTF App Now</p>

      <div className="qr-code">
        {qr_code ? (
          <QRCodeCanvas value={qr_code} size={150} level="H" />
        ) : (
          <p className="no-content">No QR code available</p>
        )}
      </div>
    </div>
  );
};

export default CheckinQr;
